import Api from '@/services/Api'

export default {
    getAllTipoActivo(){
        return Api().get('tipoActivo/getAll')
    },
    getTipoActivoById(id){
        return Api().get('tipoActivo/tipoActivoById/'+id)
    },
    createTipoActivo(datos){
        return Api().post('tipoActivo/create',datos)
    },
    updateActivoById(datos){
        return Api().put('tipoActivo/update',datos)
    },
    deleteTipoActivo(id){
        return Api().delete('tipoActivo/delete/'+id)
    }
}